import { render, staticRenderFns } from "./DvEmpty.vue?vue&type=template&id=cfd4bb6e&scoped=true&"
import script from "./DvEmpty.vue?vue&type=script&lang=ts&"
export * from "./DvEmpty.vue?vue&type=script&lang=ts&"
import style0 from "./DvEmpty.vue?vue&type=style&index=0&id=cfd4bb6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd4bb6e",
  null
  
)

export default component.exports